import { UserId } from "./common";

/** Task type/category for scheduler (only Auto Assign for now) */
export enum TaskType {
  AutoAssign = 'Auto Assign'
}

/** A scheduled task */
export interface SchedulerTask {
  id: string;
  taskType: TaskType;
  /** Agent user ids as bigint-serialized strings (for Auto Assign task type) */
  users?: UserId[];
  /** ISO date string or datetime for start */
  start: string;
  /** ISO date string or datetime for end (for all-day: end of day) */
  end: string;
  /** If true, task spans whole day(s) */
  allDay?: boolean;
  /** IANA timezone for this task (e.g. Europe/Istanbul). Used for display and backend runs. */
  timezone?: string | null;
  description?: string;
}

/** Selection: specific time slots (30 min) on a single day */
export interface HoursSelection {
  type: 'hours';
  date: Date;
  /** Inclusive start slot index (0-47), each slot = 30 minutes */
  startSlot: number;
  /** Exclusive end slot index (1-48) */
  endSlot: number;
}

/** Selection: whole day */
export interface DaySelection {
  type: 'day';
  date: Date;
}

/** Selection: date range (whole days) */
export interface RangeSelection {
  type: 'range';
  startDate: Date;
  endDate: Date;
}

export type SchedulerSelection = HoursSelection | DaySelection | RangeSelection;
